import { Box, Text } from "@chakra-ui/react";

export default function Footer() {
  return (
    <div>
      <Box ml="auto" mr="auto" width="100%" borderRadius={3} textAlign="center">
        <Text color="white" fontSize="lg">
          2022 &copy; Qatar University Machine Learning Lab. Created By{" "}
          <a href="https://github.com/TanjimAnim">Tanjim Ahmed</a>
        </Text>
      </Box>
    </div>
  );
}
